<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="savePainLevel">
        <mdb-modal class="custom-width" side position="right" size="lg" fullHeight direction="right" :show="modal" @close="close">
          <mdb-modal-header>
              <mdb-modal-title class="h4">Schmerzkurve erstellen</mdb-modal-title>
          </mdb-modal-header>
          <mdb-modal-body class="example-card scrollbar-blue thin">
            <mdb-stepper
              v-model="currentStep"
              simpleH
              :steps="steps"
              validation
              :validatedSteps="validatedSteps"
            >
            <template #1>
              <div class="mx-4">
                <mdb-switch
                  v-model="form.KamMitSchmerz"
                  class="mt-2"
                  color="primary"
                  offLabel=""
                  onLabel="Kam mit Schmerzen"/>
                <validation-provider
                  name="Schmerzen seit"
                  :rules="form.KamMitSchmerz ? '' : 'required'"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-date-picker
                    v-model="datum"
                    disabledFuture
                    label="Schmerzen seit"
                    name="Schmerzen seit"
                    :option="optionDatePicker"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    outline
                    :disabled="form.KamMitSchmerz"
                    @getValue="getPickersValue"
                  />
                </validation-provider>
                <validation-provider
                  name="Ort des Schmerzes"
                  rules="required|max:30"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-input
                    ref="ort"
                    id="ortdes"
                    v-model="form.Ort"
                    label="Ort des Schmerzes"
                    name="Ort des Schmerzes"
                    validation
                    required
                    outline
                  />
                </validation-provider>
                <validation-provider
                    name="Schmerzauslöser"
                    rules="max:50"
                    v-slot="{ errors, valid, validated }"
                    slim
                >
                    <mdb-input
                      v-model="form.Ausloeser"
                      label="Schmerzauslöser"
                      name="Schmerzauslöser"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                </validation-provider>
                <validation-provider
                    name="Schmerzhäufigkeit"
                    rules="max:50"
                    v-slot="{ errors, valid, validated }"
                    slim
                >
                    <mdb-input
                      v-model="form.Haeufigkeit"
                      label="Schmerzhäufigkeit"
                      name="Schmerzhäufigkeit"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                </validation-provider>
                <validation-provider
                  name="Schmerzverstärkung durch"
                  rules="max:50"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                    <mdb-input
                      v-model="form.Verstaerkung"
                      label="Schmerzverstärkung durch"
                      name="Schmerzverstärkung durch"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                </validation-provider>
                <validation-provider
                  name="Schmerzverringerung durch"
                  rules="max:50"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                    <mdb-input
                      v-model="form.Verringerung"
                      label="Schmerzverringerung durch"
                      name="Schmerzverringerung durch"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      outline
                    />
                </validation-provider>
                <validation-provider
                  name="Nicht mehr aufgetreten seit"
                  rules=""
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-date-picker
                    v-model="nichtMehrSeit"
                    disabledFuture
                    label="Nicht mehr aufgetreten seit"
                    name="Nicht mehr aufgetreten seit"
                    :option="optionDatePicker"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    outline
                    @getValue="getPickersNichtValue"
                  />
                </validation-provider>
                <validation-provider
                  name="Nicht mehr aufgetreten seit"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <label>Schmerzintensität Selbsteinschätzung</label>
                  <mdb-rating
                    v-model="form.Intensitaet"
                    far
                    :options="rateOptions"
                    :activeFar="false"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                  />
                </validation-provider>
              </div>
            </template>
            <template #2>
              <div class="mx-4">
                <span>Beurteilung BESD</span>
                <validation-provider
                  name="Atmung"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                  >
                  <mdb-select
                    outline
                    id="beurteilung_atmung"
                    v-model="AtmungArray"
                    label="Atmung"
                    name="Atmung"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    @getValue="setAtmungValue"
                  />
                </validation-provider>
                <validation-provider
                  name="Negative Lautäußerung"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-select
                    outline
                    id="Negative_Lautaeuberung"
                    v-model="Negative_Lautaeuberung_Array"
                    label="Negative Lautäußerung"
                    name="Negative Lautäußerung"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    @getValue="setNegativeValue"
                  />
                </validation-provider>
                <validation-provider
                  name="Gesichtsausdruck"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                  >
                    <mdb-select
                      outline
                      id="schicht"
                      v-model="GesichtsausdruckArray"
                      label="Gesichtsausdruck"
                      name="Gesichtsausdruck"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                      @getValue="setGesichtsausdruckValue"
                    />
                </validation-provider>
                <validation-provider
                  name="Koerpersprache"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                  >
                  <mdb-select
                    outline
                    id="Beurteilung_Koerpersprache"
                    v-model="KoerperspracheArray"
                    label="Koerpersprache"
                    name="Koerpersprache"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    @getValue="setKoerperspracheValue"
                  />
                </validation-provider>
                <validation-provider
                  name="Trost"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                  >
                  <mdb-select
                    outline
                    id="trost"
                    v-model="TrostArray"
                    label="Trost"
                    name="Trost"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    @getValue="setTrostValue"
                  />
                </validation-provider>
                <mdb-switch
                  v-model="form.Dauertmedikation"
                  class="mt-4"
                  color="primary"
                  offLabel=""
                  onLabel="Dauerschmerzmedikation nach AVO?"/>
                <mdb-switch
                  v-model="form.Bedarfmedikation"
                  class="mt-4"
                  color="primary"
                  offLabel=""
                  onLabel="Bedarfsmedikation nach AVO?"/>
              </div>
            </template>
            <template #3>
              <div class="mx-4">
                <validation-provider
                  name="Sonstige Maßnahmen"
                  rules="max:500"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-input
                    v-model="form.Massnahmen"
                    type="textarea"
                    :rows="5"
                    label="Sonstige Maßnahmen"
                    name="Sonstige Maßnahmen"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    outline
                  />
                </validation-provider>
                <label>Schmerzhistorie</label>
                <mdb-row class="d-flex flex-wrap">
                  <mdb-col xs="12" sm="6" md="6">
                    <validation-provider
                      name="Stechend"
                      rules=""
                      v-slot="{ errors, valid, validated }"
                      slim
                    >
                      <mdb-input
                        v-model="form.Art_Stechend"
                        type="checkbox"
                        id="art_Stechend"
                        name="Stechend"
                        label="Stechend"
                        class="mb-2"
                        :customValidation="validated"
                        :isValid="valid"
                        :invalidFeedback="errors[0]"
                        validFeedback="sieht gut aus"
                      />
                    </validation-provider>
                  </mdb-col>
                  <mdb-col xs="12" sm="6" md="6">
                    <validation-provider
                      name="Brennend"
                      rules=""
                      v-slot="{ errors, valid, validated }"
                      slim
                    >
                      <mdb-input
                        v-model="form.Art_Brennend"
                        type="checkbox"
                        id="art_Brennend"
                        name="Brennend"
                        label="Brennend"
                        class="mb-2"
                        :customValidation="validated"
                        :isValid="valid"
                        :invalidFeedback="errors[0]"
                        validFeedback="sieht gut aus"
                      />
                    </validation-provider>
                  </mdb-col>
                  <mdb-col xs="12" sm="6" md="6">
                    <validation-provider
                      name="Drueckend"
                      rules=""
                      v-slot="{ errors, valid, validated }"
                      slim
                    >
                      <mdb-input
                        v-model="form.Art_Drueckend"
                        type="checkbox"
                        id="art_Drueckend"
                        name="Drueckend"
                        label="Drückend"
                        class="mb-2"
                        :customValidation="validated"
                        :isValid="valid"
                        :invalidFeedback="errors[0]"
                        validFeedback="sieht gut aus"
                      />
                    </validation-provider>
                  </mdb-col>
                  <mdb-col xs="12" sm="6" md="6">
                    <validation-provider
                      name="Krampfartig"
                      rules=""
                      v-slot="{ errors, valid, validated }"
                      slim
                    >
                      <mdb-input
                        v-model="form.Art_Krampfaertig"
                        type="checkbox"
                        id="art_Krampfartig"
                        name="Krampfartig"
                        label="Krampfartig"
                        class="mb-2"
                        :customValidation="validated"
                        :isValid="valid"
                        :invalidFeedback="errors[0]"
                        validFeedback="sieht gut aus"
                      />
                    </validation-provider>
                  </mdb-col>
                  <mdb-col xs="12" sm="6" md="6">
                  <validation-provider
                    name="Pulsierend"
                    rules=""
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Art_Pulsierend"
                      type="checkbox"
                      id="art_Pulsierend"
                      name="Pulsierend"
                      label="Pulsierend"
                      class="mb-2"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                    />
                  </validation-provider>
                  </mdb-col>
                </mdb-row>
                <validation-provider
                  name="Sonstige"
                  rules="max:30"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-input
                    v-model="form.Art_Sonstige"
                    label="Sonstige"
                    name="Sonstige"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    outline
                  />
                </validation-provider>
                <label>Begleitbeschwerden</label>
                <mdb-row class="d-flex flex-wrap">
                  <mdb-col xs="12" sm="6" md="6">
                    <validation-provider
                      name="Uebelkeit"
                      rules=""
                      v-slot="{ errors, valid, validated }"
                      slim
                    >
                      <mdb-input
                        v-model="form.Beschwerden_Uebelkeit"
                        type="checkbox"
                        id="beschwerden_Uebelkeit"
                        name="Uebelkeit"
                        label="Übelkeit"
                        class="mb-2"
                        :customValidation="validated"
                        :isValid="valid"
                        :invalidFeedback="errors[0]"
                        validFeedback="sieht gut aus"
                      />
                    </validation-provider>
                  </mdb-col>
                  <mdb-col xs="12" sm="6" md="6">
                    <validation-provider
                      name="Schlaflosigkeit"
                      rules=""
                      v-slot="{ errors, valid, validated }"
                      slim
                    >
                      <mdb-input
                        v-model="form.Beschwerden_Schlaflosigkeit"
                        type="checkbox"
                        id="beschwerden_Schlaflosigkeit"
                        name="Schlaflosigkeit"
                        label="Schlaflosigkeit"
                        class="mb-2"
                        :customValidation="validated"
                        :isValid="valid"
                        :invalidFeedback="errors[0]"
                        validFeedback="sieht gut aus"
                      />
                    </validation-provider>
                  </mdb-col>
                  <mdb-col xs="12" sm="6" md="6">
                    <validation-provider
                      name="Verstopfung"
                      rules=""
                      v-slot="{ errors, valid, validated }"
                      slim
                    >
                      <mdb-input
                        v-model="form.Beschwerden_Verstopfung"
                        type="checkbox"
                        id="beschwerden_Verstopfung"
                        name="Verstopfung"
                        label="Verstopfung"
                        class="mb-2"
                        :customValidation="validated"
                        :isValid="valid"
                        :invalidFeedback="errors[0]"
                        validFeedback="sieht gut aus"
                      />
                    </validation-provider>
                  </mdb-col>
                  <mdb-col xs="12" sm="6" md="6">
                    <validation-provider
                      name="Depression"
                      rules=""
                      v-slot="{ errors, valid, validated }"
                      slim
                    >
                      <mdb-input
                        v-model="form.Beschwerden_Depression"
                        type="checkbox"
                        id="beschwerden_Depression"
                        name="Depression"
                        label="Depression"
                        class="mb-2"
                        :customValidation="validated"
                        :isValid="valid"
                        :invalidFeedback="errors[0]"
                        validFeedback="sieht gut aus"
                      />
                    </validation-provider>
                  </mdb-col>
                  <mdb-col xs="12" sm="6" md="6">
                  <validation-provider
                    name="Magenbeschwerden"
                    rules=""
                    v-slot="{ errors, valid, validated }"
                    slim
                  >
                    <mdb-input
                      v-model="form.Beschwerden_Magenbeschwerden"
                      type="checkbox"
                      id="beschwerden_Magenbeschwerden"
                      name="Magenbeschwerden"
                      label="Magenbeschwerden"
                      class="mb-2"
                      :customValidation="validated"
                      :isValid="valid"
                      :invalidFeedback="errors[0]"
                      validFeedback="sieht gut aus"
                    />
                  </validation-provider>
                  </mdb-col>
                </mdb-row>
                <validation-provider
                  name="Sonstige"
                  rules="max:30"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-input
                    v-model="form.Beschwerden_Sonstige"
                    label="Sonstige"
                    name="Sonstige"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    outline
                  />
                </validation-provider>
              </div>
            </template>
            </mdb-stepper>
          </mdb-modal-body>
          <mdb-modal-footer>
              <mdb-btn
                v-if="currentStep==1"
                color="grey lighten-1"
                @click.native="close"
              >
                Zurück
              </mdb-btn>
              <mdb-btn
                v-else
                color="grey lighten-1"
                @click.native="stepBackChange"
              >
                Zurück
              </mdb-btn>

              <mdb-btn
                v-if="currentStep==1 || currentStep==2"
                color="primary"
                @click.native="stepChange"
              >
                Weiter <mdb-icon icon="angle-right" />
              </mdb-btn>
              <mdb-btn
                v-else
                color="primary"
                :disabled="loading"
                type="submit"
              >
                <template v-if="!loading">
                  Erstellen <mdb-icon icon="save" />
                </template>
                <template v-else>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Verladung
                </template>
              </mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import utils from '@/mixins/Utils'
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbDatePicker,
    mdbIcon,
    mdbInput,
    mdbSwitch,
    mdbRating,
    mdbStepper,
    mdbSelect,
    mdbRow,
    mdbCol
  } from 'mdbvue';

  export default {
    name: 'AddPainLevelModal',
    mixins: [utils()],
    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbDatePicker,
      mdbIcon,
      mdbInput,
      mdbSwitch,
      mdbRating,
      mdbStepper,
      mdbSelect,
      mdbRow,
      mdbCol
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        modal: false,
        loading: false,
        datum: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        nichtMehrSeit: '',
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        form: {
          GastId: '',
          Datum: '',
          KamMitSchmerz: false,
          Seit: '',
          Ort: '',
          Ausloeser: '',
          Haeufigkeit: '',
          Verstaerkung: '',
          Verringerung: '',
          NichtMehrSeit: '',
          Intensitaet: 0,
          Intensitaet_BESD: 0,
          Atmung: '',
          Negative_Lautaeuberung: '',
          Gesichtsausdruck: '',
          Koerpersprache: '',
          Trost: '',
          Dauertmedikation: false,
          Bedarfmedikation: false,
          Massnahmen: '',
          Art_Stechend: false,
          Art_Brennend: false,
          Art_Drueckend: false,
          Art_Krampfaertig: false,
          Art_Pulsierend: false,
          Art_Sonstige: false,
          Beschwerden_Uebelkeit: false,
          Beschwerden_Schlaflosigkeit: false,
          Beschwerden_Verstopfung: false,
          Beschwerden_Depression: false,
          Beschwerden_Magenbeschwerden: false,
          Beschwerden_Sonstige: false,
          AenderungVon: '',
          AenderungAm: '',
        },
        defaultForm: {
          GastId: '',
          Datum: '',
          KamMitSchmerz: false,
          Seit: '',
          Ort: '',
          Ausloeser: '',
          Haeufigkeit: '',
          Verstaerkung: '',
          Verringerung: '',
          NichtMehrSeit: '',
          Intensitaet: 0,
          Intensitaet_BESD: 0,
          Atmung: '',
          Negative_Lautaeuberung: '',
          Gesichtsausdruck: '',
          Koerpersprache: '',
          Trost: '',
          Dauertmedikation: false,
          Bedarfmedikation: false,
          Massnahmen: '',
          Art_Stechend: false,
          Art_Brennend: false,
          Art_Drueckend: false,
          Art_Krampfaertig: false,
          Art_Pulsierend: false,
          Art_Sonstige: false,
          Beschwerden_Uebelkeit: false,
          Beschwerden_Schlaflosigkeit: false,
          Beschwerden_Verstopfung: false,
          Beschwerden_Depression: false,
          Beschwerden_Magenbeschwerden: false,
          Beschwerden_Sonstige: false,
          AenderungVon: '',
          AenderungAm: '',
        },
        steps: [
          { name: "Leistung" },
          { name: "Beurteilung" },
          { name: "Schmerzhistorie" }
        ],
        currentStep: 1,
        validatedSteps: {}
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    methods: {
      close () {
        this.datum = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),
        this.form = Object.assign({}, this.defaultForm)
        this.AtmungArray.find(option => {
          option.selected = false
        })
        this.Negative_Lautaeuberung_Array.find(option => {
          option.selected = false
        })
        this.GesichtsausdruckArray.find(option => {
          option.selected = false
        })
        this.KoerperspracheArray.find(option => {
          option.selected = false
        })
        this.TrostArray.find(option => {
          option.selected = false
        })
        this.$emit('close')
      },

      save () {
        this.close()
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.datum = value
        }
      },

      getPickersNichtValue (value) {
        if(value) {
          this.nichtMehrSeit = value
        }
      },

      setAtmungValue (value) {
        this.form.Atmung = value
      },

      setNegativeValue (value) {
        this.form.Negative_Lautaeuberung = value
      },

      setGesichtsausdruckValue (value) {
        this.form.Gesichtsausdruck = value
      },

      setKoerperspracheValue (value) {
        this.form.Koerpersprache = value
      },

      setTrostValue (value) {
        this.form.Trost = value
      },

      savePainLevel() {
        // make step back
        if (this.currentStep == 3) {
          this.currentStep += 1
          return
        }


        this.form.Datum = this.formatDateY(this.datum)
        this.form.NichtMehrSeit = this.formatDateY(this.nichtMehrSeit)

        this.form.Datum = this.form.Datum ? this.serverDateFormat(new Date(this.form.Datum+ ' ' +this.uhrzeit)) : ''
        this.form.Seit = this.form.Datum
        this.form.NichtMehrSeit = this.form.NichtMehrSeit ? this.serverDateFormat(new Date(this.form.NichtMehrSeit+ ' ' +this.uhrzeit)) : ''
        this.form.GastId = this.roomID
        this.form.AenderungVon = this.loginUser.username
        this.form.AenderungAm = this.form.Datum

        let atmung = this.form.Atmung!== '' ? parseInt(this.form.Atmung) : 0
        let negative_Lautaeuberung = this.form.Negative_Lautaeuberung!== '' ? parseInt(this.form.Negative_Lautaeuberung) : 0
        let gesichtsausdruck = this.form.Gesichtsausdruck!== '' ? parseInt(this.form.Gesichtsausdruck) : 0
        let koerpersprache = this.form.Koerpersprache!== '' ? parseInt(this.form.Koerpersprache) : 0
        let trost = this.form.Trost!== '' ? parseInt(this.form.Trost) : 0

        this.form.Intensitaet_BESD = atmung + negative_Lautaeuberung + gesichtsausdruck +
                              koerpersprache + trost

        this.loading = true
        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
        }

          this.$http.post('/Schmerzkurve', this.form)
            .then(res => {
              if(res.data) {
                  this.$notify.success({message: 'Schmerzkurve erstellen erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})
                  this.save()
              }else {
                  this.$notify.error({message: 'Gescheitert Schmerzkurve erstellen!!', position: 'top right', closeButton: false, timeOut: 5000})
              }
            })
            .catch((error) => {
              this.$notify.error({message: error.response.data.ResponseStatus.Message, position: 'top right', closeButton: false, timeOut: 5000})
            })
            .finally(() => {
              this.loading = false
            })

          // Wait until the models are updated in the UI
          this.$nextTick(() => {
            this.$refs.form.reset()
          });
        });
      },

      stepChange () {
        this.validate(this.currentStep)
      },

      stepBackChange () {
        this.currentStep === 3 ? this.currentStep -= 1 : this.currentStep -= 1
      },

      validate(step) {
        let ortdes = document.getElementById('ortdes')
        if (step === 1) {
          if(this.$refs.ort.innerValue) {
            ortdes.classList.remove('is-invalid')
            ortdes.classList.add('is-valid')

            this.validatedSteps[1] = true
            this.currentStep += 1
          }else {
            ortdes.classList.remove('is-valid')
            ortdes.classList.add('is-invalid')
          }
        }
        else if (step === 2)
        {
          this.validatedSteps[2] = true
          this.currentStep += 1
        }
        else if (step === 3)
        {
          this.validatedSteps[3] = true
          this.currentStep += 1
        }
      }
    }
  }
</script>
